var _a;
import { bestbuyCustomEventSchemas } from '@/events/constants/custom-event-schemas.constant';
import { getEventTracker } from 'hx-analytics';
export var useEvents = (_a = getEventTracker(bestbuyCustomEventSchemas), _a.useEvents), trackCustom = _a.trackCustom;
